import {
  deleteValues,
  payloadBool,
  payloadFormatArray,
  payloadKeyVal,
  payloadKeyVals,
} from "helpers/utils/utilities";
import { isTrue } from "helpers/utils/validators";
export const browse_options = [
  {
    id: 1,
    title: `Browse`,
    pageTitle: "Browse Labs and Lab Programs",
  },
  {
    id: 2,
    title: `My Labs & Lab Programs`,
    pageTitle: "My Labs & Lab Programs",
  },
  {
    id: 3,
    title: "Pending Invitations",
    pageTitle: "Browse Pending Lab & Lab Programs Invitations",
  },
  {
    id: 4,
    title: "Saved",
    pageTitle: "Browse Saved Labs & Lab Programs",
  },
];

export const labProgramPayload = ({ data, labs, experts, editMode, isDraft }) =>{
    let payload = {
      ...data,
      lab_ids: labs.selected.map((d) => d.uuid),
      status: isDraft === true ? "draft" : "publish",
      media_type:
        data?.iframe_code ||
        (typeof data?.media === "string" && data?.media?.startsWith("<iframe"))
          ? "embedded"
          : "image",
      media: data?.iframe_code ? data?.iframe_code : data?.media,
      is_achievement_enabled: payloadBool(data?.is_achievement_enabled),
      expert_references: payloadFormatArray(experts, "email"),
      is_pre_built_achievement: payloadBool(
        Boolean(data?.pre_built_achievement_id)
      ),
    };

    if (isTrue(payload.is_pre_built_achievement))
      payload["achievement_id"] = data.pre_built_achievement_id;

    payloadKeyVal(payload, ["level_id", "duration_id", "category_id"]);
    payloadKeyVals(payload, ["skills", "skill_groups", "skill_stacks"]);
    const deleteVals = [
      "lab",
      "labs",
      "id",
      "iframe_code",
      "pre_built_achievement_id",
    ];

    if (editMode) {
      if (
        typeof data.media === "string" &&
        payload?.media_type !== "embedded"
      ) {
        deleteVals.push("media");
      }

      if (typeof data.achievement_image === "string") {
        deleteVals.push("achievement_image");
      }
    }
    if (!data?.skill_groups || !data?.skill_groups.length) {
      deleteVals.push("skill_groups");
    }
    if (!data?.skill_stacks || !data?.skill_stacks.length) {
      deleteVals.push("skill_stacks");
    }

    if (!data?.skills || !data?.skills.length) {
      deleteVals.push("skills");
    }

    if (!data?.is_achievement_enabled) {
      deleteVals.push("achievement_image");
      deleteVals.push("achievement_name");
      deleteVals.push("achievement_points");
    }

    if (data.is_achievement_enabled) {
      payload = {
        ...payload,
        old_winner_achievement_image: data?.achievement_image,
      };
    }
    deleteValues(payload, deleteVals);

    return payload;
}